import React from "react";
import Portal from "components/Portal";

interface MessageDialogProps {
  children: React.ReactNode;
}

const MessageDialog: React.FC<MessageDialogProps> = ({ children }) => {
  return (
    <Portal>
      <div className="fixed inset-0 z-[120] flex items-center justify-center bg-black/50 p-4">
        <div className="z-[121] w-full max-w-[680px] rounded-[4px] bg-white px-8 py-7 shadow-[0_16px_40px_rgba(0,0,0,0.28)]">
          {children}
        </div>
      </div>
    </Portal>
  );
};

export default MessageDialog;
